const TYPES = {
    START_TALON: 'START_TALON',
    START_TALON_COMPLETE: 'START_TALON_COMPLETE',
    START_TALON_FAILED: 'START_TALON_FAILED',

    UPDATE_SOLVE_TOKEN: 'UPDATE_SOLVE_TOKEN',
    UPDATE_SOLVE_TOKEN_COMPLETE: 'UPDATE_SOLVE_TOKEN_COMPLETE',
    UPDATE_SOLVE_TOKEN_FAILED: 'UPDATE_SOLVE_TOKEN_FAILED',

    RESET_TALON: 'RESET_TALON',
    RESET_TALON_COMPLETE: 'RESET_TALON_COMPLETE',
    RESET_TALON_FAILED: 'RESET_TALON_FAILED'
};

export default {
    TYPES,

    start: () => ({
        type: TYPES.START_TALON
    }),

    startSuccess: () => ({
        type: TYPES.START_TALON_COMPLETE
    }),

    startFailed: (error?) => ({
        type: TYPES.START_TALON_FAILED,
        payload: {error}
    }),

    updateSolveToken: (payload?) => ({
        type: TYPES.UPDATE_SOLVE_TOKEN,
        payload
    }),

    updateSolveTokenSuccess: (payload?) => ({
        type: TYPES.UPDATE_SOLVE_TOKEN_COMPLETE,
        payload
    }),

    updateSolveTokenFailed: (error?) => ({
        type: TYPES.UPDATE_SOLVE_TOKEN_FAILED,
        payload: {error}
    }),

    reset: () => ({
        type: TYPES.RESET_TALON
    }),

    resetSuccess: () => ({
        type: TYPES.RESET_TALON_COMPLETE
    }),

    resetFailed: (error?) => ({
        type: TYPES.RESET_TALON_FAILED,
        payload: {error}
    })
};
